import script from "./OpenLoadView.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenLoadView.vue?vue&type=script&setup=true&lang=js"

import "./OpenLoadView.vue?vue&type=style&index=0&id=b3ea68e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3ea68e8"]])

export default __exports__